import { useEventDetails } from '../event-detail.route';

export default function EventDetailsTitle() {
  const data = useEventDetails();
  const event = data?.event;

  if (!event) {
    return null;
  }

  return (
    <div className="ml-2 flex flex-col items-start gap-2">
      <div className="type-body-2xl font-medium text-zinc-900">{event.title}</div>
      <div className="type-body-sm leading-6 text-zinc-500">{event.summary}</div>
    </div>
  );
}
